module.exports = __webpack_public_path__ + "public/SiteImages/bbq.svg?fd16951a";


//////////////////
// WEBPACK FOOTER
// ./public/SiteImages/bbq.svg
// module id = 1000
// module chunks = 8